import axios from 'axios';
import {v4 as uuidv4} from 'uuid';

import Store from '../../redux/Store';
import { getAccessToken } from './msalUtils';
import { ApiPath, ApiPathRESE } from '../api-path/ApiPath';


axios.interceptors.request.use(async req => {
  Store.dispatch({ type:'INCREMENT'});

  const token = await getAccessToken();
  if (token) {
    req.headers['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('No access token available for API request to:', req.url);
  }
  req.headers['X-correlation-id'] = uuidv4();
  // Important: request interceptors **must** return the request.
  return req;
});

// axios.interceptors.response.use(res => {
//   // Important: response interceptors **must** return the response.
//   Store.dispatch({ type:'DECREMENT'})
//   if(res.config.url.includes("exclusionRule") && res.config.method==="post") {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Changes in Exclusion Rule will be reflected within 1 hour"})
//   } else if(res.config.url===`${ApiPath.baseUrl}/modem/command`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Command Sent Successfully"})
//   } else if(res.config.url===`${ApiPath.baseUrl}/merakifirewall/modifyschedule`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "You are successfully modified the schedule.You can see the changes reflected against the Request ID."})
//   } else if(res.config.url===`${ApiPath.baseUrl}/shelly-upgrade/createcampaign`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Campaign created successfully"})
//   } else if(res.config.url===`${ApiPath.baseUrl}/shelly-upgrade/creategroup`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Group created successfully"})
//   }else if(res.config.url===`${ApiPath.baseUrl}/shelly-upgrade/updategroup`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Group Details modified successfully"})
//   }else if(res.config.url===`${ApiPath.baseUrl}/shelly-upgrade/updatecampaign`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Campaign Details modified successfully"})
//   }else if(res.config.url===`${ApiPath.baseUrl}/incsuppression/request` || res.config.url===`${ApiPath.baseUrl}/addAlertSuppressionDetails`) {
//     Store.dispatch({ type:'HIDE'})
//     Store.dispatch({ type:'SHOW', payload: "Request Submitted Successfully"})
//   }
//   // else if(res.config.url===`${ApiPath.baseUrl}/GrafanaAgent/create/job`) {
//   //   Store.dispatch({ type:'HIDE'})
//   //   Store.dispatch({ type:'SHOW', payload: res.data})}
//   //   else if(res.config.url===`${ApiPath.baseUrl}/GrafanaAgent/execute/job`) {
//   //   Store.dispatch({ type:'HIDE'})
//   //   Store.dispatch({ type:'SHOW', payload: res.data})
//   // }
//   return res;
// },err=>{
//      Store.dispatch({ type:'DECREMENT'}) 
//     if((err.config.url===`${ApiPath.baseUrl}/merakifirewall/modifyschedule`) || (err.config.url===`${ApiPath.baseUrl}/merakifirewall/cancel`)){
//       Store.dispatch({ type:'HIDE'})
//       Store.dispatch({ type:'SHOW', payload: err.response && err.response.data})
//     }else if((err.config.url===`${ApiPath.baseUrl}/shelly-upgrade/createcampaign`) || (err.config.url===`${ApiPath.baseUrl}/shelly-upgrade/creategroup`)
//     || (err.config.url===`${ApiPath.baseUrl}/shelly-upgrade/updategroup`) || (err.config.url===`${ApiPath.baseUrl}/shelly-upgrade/updatecampaign`)) {
//       Store.dispatch({ type:'HIDE'})
//       Store.dispatch({ type:'SHOW', payload: err.response && err.response.data.detailList[0]})
//     }
//     //  else if(err.config.url===`${ApiPath.baseUrl}/GrafanaAgent/execute/job`) {
//     //   Store.dispatch({ type:'HIDE'})
//     //   Store.dispatch({ type:'SHOW', payload: err.data})
//     // }
//     // else if(err.config.url===`${ApiPath.baseUrl}/GrafanaAgent/create/job`) {
//     //   Store.dispatch({ type:'HIDE'})
//     //   Store.dispatch({ type:'SHOW', payload: err.response && err.response.data })}
   
//     else {
//       Store.dispatch({ type:'HIDE'})
//       Store.dispatch({ type:'SHOW', payload: err.response && err.response.data.message})
//     } 
//     console.error(err);
//     return Promise.reject(err);
// });

const showToaster = (message) => {
  Store.dispatch({ type: 'HIDE' }); // Hide any existing toaster
  setTimeout(() => {
    Store.dispatch({ type: 'SHOW', payload: message }); // Show the new toaster after a short delay
  }, 100); // Delay of 100ms
};

axios.interceptors.response.use(
  (res) => {
    Store.dispatch({ type: 'DECREMENT' });

    if (res.config.url.includes("exclusionRule") && res.config.method === "post") {
      showToaster("Changes in Exclusion Rule will be reflected within 1 hour");
    } else if (res.config.url === `${ApiPath.baseUrl}/modem/command`) {
      showToaster("Command Sent Successfully");
    } else if (res.config.url === `${ApiPath.baseUrl}/merakifirewall/modifyschedule`) {
      showToaster("You are successfully modified the schedule. You can see the changes reflected against the Request ID.");
    } else if (res.config.url === `${ApiPath.baseUrl}/shelly-upgrade/createcampaign`) {
      showToaster("Campaign created successfully");
    } else if (res.config.url === `${ApiPath.baseUrl}/shelly-upgrade/creategroup`) {
      showToaster("Group created successfully");
    } else if (res.config.url === `${ApiPath.baseUrl}/shelly-upgrade/updategroup`) {
      showToaster("Group Details modified successfully");
    } else if (res.config.url === `${ApiPath.baseUrl}/shelly-upgrade/updatecampaign`) {
      showToaster("Campaign Details modified successfully");
    } else if (
      res.config.url === `${ApiPath.baseUrl}/incsuppression/request` ||
      res.config.url === `${ApiPath.baseUrl}/addAlertSuppressionDetails`
    ) {
      showToaster("Request Submitted Successfully");
    }

    return res;
  },
  (err) => {
    Store.dispatch({ type: 'DECREMENT' });

    if (
      err.config.url === `${ApiPath.baseUrl}/merakifirewall/modifyschedule` ||
      err.config.url === `${ApiPath.baseUrl}/merakifirewall/cancel`
    ) {
      showToaster(err.response && err.response.data);
    } else if (
      err.config.url === `${ApiPath.baseUrl}/shelly-upgrade/createcampaign` ||
      err.config.url === `${ApiPath.baseUrl}/shelly-upgrade/creategroup` ||
      err.config.url === `${ApiPath.baseUrl}/shelly-upgrade/updategroup` ||
      err.config.url === `${ApiPath.baseUrl}/shelly-upgrade/updatecampaign`
    ) {
      showToaster(err.response && err.response.data.detailList[0]);
    } else if (err.config.url === `${ApiPathRESE.baseUrl}/upsertMonitoringDetails`) {
      // Leak Detection Monitoring Request already shows its own scoped,
      // auto-dismissing error toast - skip the global toaster to avoid
      // showing two duplicate error popups.
    } else {
      showToaster(err.response && err.response.data.message);
    }
    return Promise.reject(err);
  }
);